import { X, ShoppingCart, Headphones } from "lucide-react";

export default function BookModal({ book, open, onClose }) {
  if (!open || !book) return null;
  const isCurrent = book.category === "current";
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm" onClick={onClose} data-testid="book-modal">
      <div className="relative bg-mahogany-950 gold-frame rounded-sm w-full max-w-3xl max-h-[90vh] overflow-y-auto p-8 sm:p-10" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-5 right-5 text-cream/60 hover:text-fuchsia" data-testid="book-modal-close"><X size={24} /></button>
        <div className="grid sm:grid-cols-5 gap-8">
          <div className="sm:col-span-2">
            <img src={book.cover_url} alt={book.title} className="w-full rounded-sm shadow-[0_15px_40px_rgba(0,0,0,0.6)]" />
          </div>
          <div className="sm:col-span-3">
            <div className="flex items-center gap-3 mb-3">
              <span className={`text-[10px] uppercase tracking-[0.2em] px-3 py-1 rounded-full font-semibold ${isCurrent ? "bg-fuchsia text-white" : "bg-gold text-mahogany-900"}`}>{isCurrent ? "Currently Reading" : "Upcoming Read"}</span>
              {book.month && <span className="text-caramel text-xs uppercase tracking-wider">Month {book.month}</span>}
            </div>
            <h2 className="font-serif text-4xl text-cream leading-none">{book.title}</h2>
            <p className="text-caramel text-lg mb-3 font-light">by {book.author}</p>
            {book.theme && <p className="font-script text-2xl text-gold mb-4">{book.theme}</p>}
            <p className="text-cream/75 leading-relaxed mb-7">{book.description}</p>
            <div className="flex flex-wrap gap-3">
              {book.purchase_url && <a href={book.purchase_url} target="_blank" rel="noreferrer" className="btn-primary inline-flex items-center gap-2" data-testid="modal-buy"><ShoppingCart size={16} /> Buy the Book</a>}
              {book.audiobook_available && book.audiobook_url && <a href={book.audiobook_url} target="_blank" rel="noreferrer" className="btn-secondary inline-flex items-center gap-2" data-testid="modal-audiobook"><Headphones size={16} /> Listen to the Audiobook</a>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
